import { Getters, Mutations, Module, createMapper } from 'vuex-smart-module'

class LoadingState {
  enqueued = 0
  processed = 0
  errors = 0
}

class LoadingGetters extends Getters<LoadingState> {
  public get showProgress() {
    return this.state.enqueued !== this.state.processed
  }
}

class LoadingMutations extends Mutations<LoadingState> {
  enqueue() {
    this.state.enqueued += 1
  }

  dequeue(ok = true) {
    this.state.processed += 1
    if (!ok) {
      this.state.errors += 1
    }
    if (this.state.enqueued <= this.state.processed) {
      this.state.enqueued = this.state.processed = this.state.errors = 0
    }
  }
}

export const loading = new Module({
  state: LoadingState,
  getters: LoadingGetters,
  mutations: LoadingMutations
})

export const loadingMapper = createMapper(loading)
